import { render, staticRenderFns } from "./SchoolPreparationBanner.vue?vue&type=template&id=79876aa8&scoped=true&lang=pug&"
var script = {}
import style0 from "./SchoolPreparationBanner.vue?vue&type=style&index=0&id=79876aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79876aa8",
  null
  
)

export default component.exports